<template>
  <div>
    <v-btn
        color="red"
        elevation="2"
        fab
        class="buzzer"
        v-on:click="buzzIn"
        fixed
        right
        bottom
    >
      <v-icon>
        mdi-bell-ring
      </v-icon>
    </v-btn>

    <v-container>
      <v-row justify="center">
        <v-card elevation="0" max-width="1024">
          <PicturePage/>
          <QuizPanel/>
        </v-card>
      </v-row>
    </v-container>
    <BuzzIn/>
  </div>
</template>

<script>
import QuizPanel from "@/components/QuizPanel";
import {mapActions} from 'vuex';
import BuzzIn from "@/components/BuzzIn";
import PicturePage from "@/components/PicturePage";

export default {
  name: 'PlayerPage',
  components: {
    PicturePage,
    BuzzIn,
    QuizPanel,
  },
  methods: {
    ...mapActions(['buzzIn']),
  },
}
</script>
<style>
.v-btn--fab.v-size--default.buzzer {
  height: 180px;
  width: 180px;
  margin-bottom: 50px;
}
</style>
